import { createContext } from 'react'
import { Route, Routes } from 'react-router-dom'
import Whatsappdashboard from '../component/Whatsappdashboard.js'
import Clientarea from '../component/Clientarea.js'
import ApplicationProtectedRouting from './ApplicationProtectedRouting'
import Notfound from '../whatsapp/small_component/notfound'
import Register from '../component/register/Register.js'
import Login from '../component/login/Login';
import { theme } from '../component/Theme/ThemeContext';
import Forgotpassword from '../component/register/Forgotpassword';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminLogin from '../component/login/AdminLogin.jsx';
import Routing from '../GoogleMyBusiness/Routing.jsx'
export const ThemeContext = createContext();

export default function ApplicationRouting() {
  return (
    <ThemeContext.Provider value={theme}>
      <GoogleOAuthProvider clientId="818905743654-rgo4fs8bpbt4fj38b5vtq1osgbu4gp9r.apps.googleusercontent.com">
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path='/client-area' element={<ApplicationProtectedRouting element={<Clientarea />} />} />
          <Route path='/client-area/whatsapp/*' element={<ApplicationProtectedRouting element={<Whatsappdashboard />} />} />
          {/* <Route path='/client-area/commercemanager/*' element={<ApplicationProtectedRouting element={<Commercemanagerdashboard/>}/>}/> */}
          <Route path='/client-area/gmb/*' element={<ApplicationProtectedRouting element={<Routing />} />} />
          <Route path='/admin_login/:token' element={<AdminLogin />} />
          <Route path='/' element={<Login />} />
          <Route path='/forgot-password' element={<Forgotpassword />} />
          <Route path='/register/:data' element={<Register />} />
          <Route path='*' element={<Notfound />} />
        </Routes>
      </GoogleOAuthProvider>
    </ThemeContext.Provider>
  )
}